[
    {
        "address": "kusama-airdrop.near"
    },
    {
        "address": "adtoken.near"
    }
]